/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_TitleInputs */

const es_admin_billing_bills_list_title = /** @type {(inputs: Admin_Billing_Bills_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las facturas`)
};

const en_admin_billing_bills_list_title = /** @type {(inputs: Admin_Billing_Bills_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All invoices`)
};

/**
* | output |
* | --- |
* | "All invoices" |
*
* @param {Admin_Billing_Bills_List_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_title = /** @type {((inputs?: Admin_Billing_Bills_List_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_title(inputs)
	return en_admin_billing_bills_list_title(inputs)
});
export { admin_billing_bills_list_title as "admin.billing.bills_list.title" }